import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import {
    Card,
    alpha,
    CardHeader,
    CardContent,
    IconButton,
    TableCell,
    TableRow,
    Tooltip,
    Stack,
    FormControl,
    FormLabel,
    Grid,
    Button,
} from '@mui/material';
import api from '../config/axios';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import TaskIcon from '@mui/icons-material/Task';
import BackspaceIcon from '@mui/icons-material/Backspace';
import ModalContainer from '../components/containers/ModalContainer';
import StatusComp from '../components/common/StatusComp';
import { useTheme } from '@emotion/react';

const InterOrders = () => {
    const [orders, setOrders] = useState([]);
    const theme = useTheme();
    const [order, setOrder] = useState({});
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');
    const [fullfilLoader, setFullFilLoader] = useState('');
    const [filter, setFilter] = useState('All');
    const [sort, setSort] = useState('asc');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [order_status, setOrder_status] = useState('');
    const [url, setUrl] = useState('/admin/international-orders/read');
    const [orderContent, setOrderContent] = useState({});
    const [search, setSearch] = useState('');
    const [showOrderDetails, setShowOrderDetails] = useState(false);
    const [validateLoader, setValidateLoader] = useState(false);
    const [CSV, setCSV] = useState('');
    const onCloseOrderDetailsModal = () => {
        setShowOrderDetails(false);
    };
    const onOpenOrderDetailsModal = () => setShowOrderDetails(true);

    const [showOrderCancel, setShowOrderCancel] = useState(false);

    const onCloseOrderCancelModal = () => {
        setShowOrderCancel(false);
    };
    const onOpenOrderCancelModal = () => setShowOrderCancel(true);

    const [showOrderFulfill, setShowOrderFulfill] = useState(false);

    const onCloseOrderFulfillModal = () => {
        setShowOrderFulfill(false);
    };
    const onOpenOrderFulfillModal = () => setShowOrderFulfill(true);

    useEffect(() => {
        getOrders();
    }, [page, sort, filter, limit, search]);

    const getOrders = async () => {
        var link = '';

        if (search !== '') {
            link =
                url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter + '&search=' + search;
        } else {
            link = url + '?page=' + page + '&limit=' + limit + '&sort=' + sort + '&status=' + filter;
        }

        await api
            .get(link)
            .then((res) => {
                setOrders(res.data.orders);
                setTotalPages(res.data.totalPages);
                setTotal(res.data.total);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const exportCSV = () => {
        // convert data into csv

        // write heading
        let csv = '';
        csv +=
            'Order ID,Status, fromName, fromEmail,fromCompany, fromAddress, fromAddress2, fromAddress3, fromZipCode,fromCity , fromState, fromCountry, toName, toEmail,toCompany, toAddress, toAddress2, toAddress3, toZipCode,toCity , toState, toCountry,product, dropoff, contentSummary, value,weight1 , length1 , width1 , height1, weight2 , length2 , width2 , height2, weight3 , length3 , width3 , height3, \n';
        // write data
        orders.forEach((order) => {
            csv += `${order._id} ,${order.status}, ${order.content.fromName} , ${order.content.fromEmail} , ${order.content.fromCompany} , ${order.content.fromAddress} , ${order.content.fromAddress2} , ${order.content.fromAddress3} , ${order.content.fromZipCode} , ${order.content.fromCity} , ${order.content.fromState} , ${order.content.fromCountry} , ${order.content.toName} , ${order.content.toEmail} , ${order.content.toCompany} , ${order.content.toAddress} , ${order.content.toAddress2} , ${order.content.toAddress3} , ${order.content.toZipCode} , ${order.content.toCity} , ${order.content.toState} , ${order.content.toCountry} , ${order.content.product} , ${order.content.dropoff} , ${order.content.content_summary}, ${order.content.value} , ${order.content.weight1},${order.content.length1},${order.content.width1},${order.content.height1},${order.content.weight2},${order.content.length2},${order.content.width2},${order.content.height2},${order.content.weight3},${order.content.length3},${order.content.width3},${order.content.height3}\n`;
        });

        // download csv file
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'orders.csv';
        link.click();
    };

    const cancelOrder = async () => {
        await api
            .put('/admin/int-order/cancel/' + order._id, {})
            .then((res) => {
                setLoader('');
                toast.success(res.data.message);
                getOrders();
                onCloseOrderCancelModal();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const fulfillOrder = async (e) => {
        e.preventDefault();
        setFullFilLoader('Fulfilling Order...');
        const params = new FormData();
        params.append('pdf', CSV);
        params.append('tracking', e.target.tracking.value);
        await api
            .put('/admin/int-order/fulfill/' + order._id, params)
            .then((res) => {
                setFullFilLoader('');
                toast.success(res.data.message);
                getOrders();
                onCloseOrderFulfillModal();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                setFullFilLoader('');
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };
    return (
        <PageContainer title="View International Orders" desc="All your active orders at one place">
            <Field
                placeholder="Search orders using order id, name, email address"
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
            />
            <CustomTable
                sx={{ mt: 2 }}
                fields={[
                    'ORDER ID',
                    'USER',
                    'TOCOUNTRY',
                    'TOTAL',
                    'LABELTYPE',
                    'TRACKING',
                    'STATUS',
                    'CREATED AT',
                    'ACTION',
                ]}
                dense={false}
                loading={loader}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {orders.map((order, index) => (
                    <TableRow key={order._id}>
                        <TableCell>{order._id}</TableCell>
                        <TableCell>{order.user?.username}</TableCell>
                        <TableCell>{order.ToCountry}</TableCell>
                        <TableCell
                            sx={{
                                color: 'success.main',
                            }}>
                            ${order.price ? order.price.toFixed(2) : '0.00'}
                        </TableCell>
                        <TableCell>{order.labelType?.name}</TableCell>
                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {order.tracking ?? 'Tracking not yet available'}
                        </TableCell>
                        <TableCell>
                            <StatusComp status={order.status} />
                        </TableCell>

                        <TableCell>{new Date(order.createdAt).toLocaleString()}</TableCell>
                        <TableCell>
                            <Stack direction="row">
                                <Tooltip title="View Order Details">
                                    <IconButton
                                        onClick={() => {
                                            setOrder(order);
                                            onOpenOrderDetailsModal();
                                        }}>
                                        <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                {order.status === 'pending' && (
                                    <>
                                        <Tooltip title="Fulfill Order">
                                            <IconButton
                                                color="success"
                                                onClick={() => {
                                                    setOrder(order);
                                                    onOpenOrderFulfillModal();
                                                }}>
                                                <TaskIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Cancel Order">
                                            <IconButton
                                                color="error"
                                                onClick={() => {
                                                    setOrder(order);
                                                    onOpenOrderCancelModal();
                                                }}>
                                                <BackspaceIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </>
                                )}
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* Order details */}
            <ModalContainer open={showOrderDetails} onClose={onCloseOrderDetailsModal} hideActions title="View Order">
                <div className="row">
                    <div className="col-lg-6">
                        <Card>
                            <CardHeader title="Sender" />

                            <CardContent>
                                <div className="card-text">
                                    <span className="fw-bold">Full Name:</span>{' '}
                                    {order.FromFirstName + ' ' + order.FromLastName} <br />
                                    <span className="fw-bold">Phone:</span> {order.FromPhone} <br />
                                    <span className="fw-bold">Email:</span> {order.FromEmail} <br />
                                    <span className="fw-bold">Road Name:</span> {order.FromStreet} <br />
                                    <span className="fw-bold">Road Number:</span> {order.FromStreet2} <br />
                                    <span className="fw-bold">City:</span> {order.FromCity} <br />
                                    <span className="fw-bold">State/Province:</span> {order.FromState} <br />
                                    <span className="fw-bold">Zip:</span> {order.FromZip} <br />
                                    <span className="fw-bold">Country:</span> {order.FromCountry} <br />
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                    <div className="col-lg-6">
                        <Card>
                            <CardHeader title="Receiver" />
                            <CardContent>
                                <div className="card-text">
                                    <span className="fw-bold">Full Name:</span>{' '}
                                    {order.ToFirstName + ' ' + order.ToLastName} <br />
                                    <span className="fw-bold">Phone:</span> {order.ToPhone} <br />
                                    <span className="fw-bold">Email:</span> {order.ToEmail} <br />
                                    <span className="fw-bold">Road Name:</span> {order.ToStreet} <br />
                                    <span className="fw-bold">Road Number:</span> {order.ToStreet2} <br />
                                    <span className="fw-bold">City:</span> {order.ToCity} <br />
                                    <span className="fw-bold">State/Province:</span> {order.ToState} <br />
                                    <span className="fw-bold">Zip:</span> {order.ToZip} <br />
                                    <span className="fw-bold">Country:</span> {order.ToCountry} <br />
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
                <div className="row mt-3 mb-3">
                    <div className="col-lg-12">
                        <Card>
                            <CardHeader title="Additional details" />

                            <CardContent>
                                <div className="card-text">
                                    <span className="fw-bold">Label Type:</span> {order.labelType?.name} <br />
                                    <span className="fw-bold">Weight:</span> {order.Weight}
                                    {order.labelType?.name.includes('First Class') ? (
                                        <span className="fw-bold">oz</span>
                                    ) : (
                                        <span className="fw-bold">lb</span>
                                    )}{' '}
                                    <br />
                                    <span className="fw-bold">Dimensions ( L x W x H):</span> {order.length} x{' '}
                                    {order.width} x {order.height}
                                    <br />
                                    <span className="fw-bold">Item Description:</span> {order.itemDescription}
                                    <br />
                                    <span className="fw-bold">Item Value:</span> {order.itemValue}
                                    <br />
                                    <span className="fw-bold">Item quantity:</span> {order.itemQuantity}
                                    <br />
                                    <span className="fw-bold">HS Tariff code:</span> {order.HSTariffcode}
                                    <br />
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </ModalContainer>

            {/* Cancel Label */}
            <ModalContainer hideActions open={showOrderCancel} onClose={onCloseOrderCancelModal} title="Cancel Label ">
                {message}
                <div className="text-center mt-0">
                    <p>Are you sure want to cancel this label?</p>
                </div>

                <div className="d-flex justify-content-between mt-4">
                    <button type="button" className="btn btn-secondary" onClick={() => onCloseOrderCancelModal()}>
                        Close
                    </button>
                    <button className="btn btn-danger" onClick={() => cancelOrder()}>
                        Cancel Label {loader}
                    </button>
                </div>
            </ModalContainer>

            {/* Fulfill Label */}
            <ModalContainer
                open={showOrderFulfill}
                onClose={onCloseOrderFulfillModal}
                title="Fulfill Label"
                hideActions>
                {message}
                <form onSubmit={fulfillOrder}>
                    <div className="form-group mb-3">
                        <label>Tracking Number</label>
                        <input type="text" className="form-control" name="tracking" required />
                    </div>
                    <Grid item xs={12} sm={3}>
                        <FormControl sx={{ height: '100%' }} fullWidth>
                            <FormLabel sx={{ fontWeight: 600, mb: 0.6 }}>Upload Label</FormLabel>
                            <Button
                                variant="outlined"
                                component="label"
                                sx={{
                                    height: '100%',
                                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                                    borderStyle: 'dashed',
                                }}>
                                {CSV?.name || '+ Upload Label File'}

                                <input
                                    type="file"
                                    id="csv"
                                    hidden
                                    name="csv"
                                    required
                                    onChange={(e) => {
                                        setCSV(e.target.files[0]);
                                    }}
                                />
                            </Button>
                        </FormControl>
                    </Grid>

                    <div className="d-flex mt-4 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-secondary me-3"
                            onClick={() => onCloseOrderFulfillModal()}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-success">
                            Fulfill {fullfilLoader}
                        </button>
                    </div>
                </form>
            </ModalContainer>
        </PageContainer>
    );
};

export default InterOrders;
